import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { environment as env } from "src/environments/environment";
// import { setTime } from "ngx-bootstrap/chronos/utils/date-setters";
@Injectable({
  providedIn: "root",
})
export class MapService {
	locationiqkey: any = null;
	address: any = null;
	street: any = null;
	city: any = null;
	state: any = null;
	country = "Philippines";
	coords = {
		lat: 14.6091,
		lng: 121.0223,
	};

	key: string = env.google_maps_key;

  	constructor(public http: HttpClient) {}

	geoCode(address): Observable<any> {
		this.street = address.street[0];
		this.city = address.city;
		this.state = address.region;
		/* return this.http.get<any>('https://us1.locationiq.com/v1/search.php?key='+this.locationiqkey+'&street='+this.street+'&city='+address.city+'&state='+this.state+'&country='+this.country+'&format=json&countrycodes=ph&limit=1'); */
		return this.http.get<any>(
		"https://maps.googleapis.com/maps/api/geocode/json?address=" +
			this.street +
			", " +
			this.city +
			", " +
			this.state +
			"&region=philippines&key=" + this.key
		);
	}

	/* Check if string is a valid latitude and longitude  */
	checkIfValidlatitudeAndlongitude(str) {
		const regexExp = /^((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)$/gi;
		return regexExp.test(str);
	}
}
